import React, { useState, useEffect } from 'react';
//import './navbar.css';
import { Link } from "react-router-dom"
import { Button} from 'react-bootstrap';
//import { TbSquareRoundedLetterA, TbCircleLetterA } from 'react-icons/tb';
import { BsPersonFillCheck } from 'react-icons/bs';
//import JSONPretty from 'react-json-pretty';
import axios from "axios";


const Feedback_della_ditta = (props) => {
//    const [somma, calcola_somma] = useState('');


const [input, SET_input] = useState('');
   
useEffect(() => {
    SET_input(prevInput => {
        return {
            ...prevInput,
            stato_attuale: props.risposta_della_ditta
        }
    })

   
}, [props.risposta_della_ditta]);
useEffect(() => {
    SET_input(prevInput => {
        return {
            ...prevInput,
            attore: props.parametro_passato
       }
    })

   
}, [props.parametro_passato]);


        
    function Scelta_programma2 (event, parametro) {
    //        event.preventDefault()
            console.log("sssssssssss  " + parametro + ' - ' + event.target.value)
            
            
        if (parametro == 0 && props.evento == 'Mattina') {
            console.log("X1  " )
         
            SET_input(prevInput => {
                return {
                    ...prevInput,
                    attore: props.parametro_passato,
                    [props.parametro_passato]: parametro,
                    stato_attuale: parametro
                }
            })
        }
        if (parametro == 0 && props.evento == 'Pomeriggio') {
            console.log("X2  " )
      
            SET_input(prevInput => {
                return {
                    ...prevInput,
                    attore: props.parametro_passato,
                    [props.parametro_passato]: parametro,
                    stato_attuale: parametro
            
                }
            })
        }
        if (parametro != 0) {
            console.log("X3  " )
      
            SET_input(prevInput => {
                return {
                    ...prevInput,
                    attore: props.parametro_passato,
                    [props.parametro_passato]: parametro, 
                    stato_attuale: parametro
                }
            })
        }
        
        const input_ausiliario ={
            id_progetto: props.id_progetto,
            id_array_presenze: props.id_array_presenze,
            attore: props.parametro_passato,
            [props.parametro_passato]: parametro, 
            stato_attuale: parametro
        } 
        axios.patch('/progetti/aggiorna_giornata_nuovo_ditta', input_ausiliario)
        .then((res) => {
//      console.log('Aggiunta una classe')
        }).catch((error) => {
            console.log('errore')
        });
    }



    function Bottone_con_tre_opzioni () {
        if (input.stato_attuale == 1) {
            return <>
                <Button onClick={(event) => Scelta_programma2(event, 0)} 
                variant="outline-primary" disabled={props.attore != null && props.attore.includes('alunno') } value={1}> {<BsPersonFillCheck color='green'  size='1.6rem'/>} </Button>
            </>
        }
        if (input.stato_attuale == 0) {
            return <>
                <Button onClick={(event) => Scelta_programma2(event, -1)} 
                variant="outline-primary" disabled={props.attore != null && props.attore.includes('alunno')} value={1}> {<BsPersonFillCheck color='red'  size='1.6rem'/>} </Button>
            </>
        }
        if (input.stato_attuale == -1) {
            return <>
                <Button onClick={(event) => Scelta_programma2(event, 1)} 
                variant="outline-primary" disabled={props.attore != null && props.attore.includes('alunno')} value={1}> {<BsPersonFillCheck color='gray'  size='1.6rem'/>} </Button>
            </>
        }
    }

    return (
    <> {Bottone_con_tre_opzioni()}
         {/*    {props.id_array_presenze}   */}
       {/*  <JSONPretty data={input} />  */}

      
         
    </>
    )
}
export default Feedback_della_ditta;